import React, { Component } from "react";
import 'antd/dist/antd.css';
import './index.css';
import { Redirect } from 'react-router-dom';
import { message, Radio, Input, Button, Row, Col } from 'antd';
const RadioGroup = Radio.Group;


let search_url = "https://in.pinterest.com/search/pins/?q=";
let gender = "men";


const inputStyling = {
  width: '60%',
}

export default class SearchPin extends Component {

  constructor() {
        super();
        this.state = {
        };
      }


  onChange(e) {
    gender = e.target.value;
  }

  pinsearch(e) {
    //preventDefault stops the page from reloading everydamntime the btn is clicked
    e.preventDefault();
    let userkeyword = document.getElementById("cloth_name").value;
    
    if(gender === '' || userkeyword === '')
    {
      message.error('Gender not selected or Input field is empty!');
    }
    else {
    let redirectWindow = window.open(
      search_url + userkeyword + " " + gender,
      "_blank"
    );
    //window.location.assign();
    <Redirect to={redirectWindow} />
  }
}

  render() {
      return (<div>
        <Row type="flex" justify="center" style={{ paddingBottom: '5px'}}>
        <h4>Can't find what to pair with those white shorts? This will help you out in such situations. </h4>
    </Row>
      <Row type="flex" justify="center">
        <Input
        type="text"
        placeholder="Enter a cloth keyword like: white shorts or blue jeans"
        id="cloth_name"
        size="large"
        style={inputStyling}
      />
      </Row>
      
    <Row gutter={16} type="flex" justify="center" >
      <RadioGroup onChange={this.onChange} defaultValue="men" size="large" style={{ paddingBottom: '10px', paddingTop: '10px'}}>
        <Col span={12}>
          <Radio value="man">
           Boy
          </Radio>
        </Col>
        <Col span={12}>
          <Radio value="woman">
          Girl
          </Radio>
        </Col>
      </RadioGroup>
    </Row>
    <Row type="flex" justify="center">
        <Button type="primary" size="large" onClick={this.pinsearch.bind(this)}>Search Outfits</Button>
    </Row>

      
    </div>);
    }
}


// WEBPACK FOOTER //
// ./src/searchpin.js